import { MicroServicesService } from './../modules/core/services/micro-services.service';
import { inject, Signal, signal } from '@angular/core';
import { FeatureFlagsService } from '../modules/core/services/feature-flags.service';
import { FeatureFlagDictionaryEnum } from '../shared/enums';
import { ResolveFn } from '@angular/router';
import { catchError, map, Observable, of, take } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as fromRoot from 'src/app/reducers';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  CruiseSurveyRetrievePayload,
  Guest,
  ReservationRetrievalResponse,
} from '../models';
import {
  PostRetrieveCruiseSurveyFailure,
  PostRetrieveCruiseSurveySuccess,
} from '../actions';

export const passengerCruiseSurveyResolver: ResolveFn<any> = ():
  | Observable<boolean> => {
  const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
  const newToCruiseSurveyFlag = signal(false);
  const featureFlagService: FeatureFlagsService = inject(FeatureFlagsService);
  const microServicesService: MicroServicesService =
    inject(MicroServicesService);

  const reservationRetrieval: Signal<ReservationRetrievalResponse> = toSignal(
    store.pipe(select(fromRoot.getSessionVar))
  );
  const guests: Signal<Guest[]> = toSignal(
    store.pipe(select(fromRoot.getSelectdGuestsForCheckinProcess))
  );

  // Set the flag for the new to cruise survey feature
  newToCruiseSurveyFlag.set(
    featureFlagService.snapshot[FeatureFlagDictionaryEnum.CRUISE_SURVEY]
  );

  if (newToCruiseSurveyFlag()) {
    return dispatchNewCruiseSurvey(
      guests(),
      reservationRetrieval(),
      microServicesService,
      store
    );
  }
  store.dispatch(new PostRetrieveCruiseSurveySuccess([]));
  return of(true);
};

const dispatchNewCruiseSurvey = (
  guests: Guest[],
  reservationRetrieval: ReservationRetrievalResponse,
  microServicesService: MicroServicesService,
  store: Store<fromRoot.AppState>
): Observable<boolean> => {
  const reservationIds = guests.map(({ guestId, consumerId = null }) => ({
    passengerId: guestId,
    consumerId:
      consumerId !== null && Number(consumerId) > 0 ? consumerId : null,
  }));
  const retrievePayload = {
    shipCode: reservationRetrieval?.shipCode,
    sailDate: reservationRetrieval?.departureDate.split('-').join(''),
    bookingId: reservationRetrieval?.bookingId,
    reservationIds,
  } as CruiseSurveyRetrievePayload;
  return microServicesService.postRetrieveCruiseSurvey(retrievePayload).pipe(
    take(1),
    map(({ payload: { passengerCruiseSurveys = [] } = {} }) => {
      store.dispatch(
        new PostRetrieveCruiseSurveySuccess(passengerCruiseSurveys)
      );
      return true;
    }),
    catchError((error) => {
      store.dispatch(new PostRetrieveCruiseSurveyFailure(error));
      return of(true);
    })
  );
};
